import MainA from 'src/components/organisms/template/StepA';
import MainB from 'src/components/organisms/template/StepB';
import MainC from 'src/components/organisms/template/StepC';
import MainD from 'src/components/organisms/template/StepD';
import MainE from 'src/components/organisms/template/StepE';
import MainBox from 'src/components/molecules/contentLayout/MainBox';

export const menuSet = () => {
  const defProps = {
    initial: { y: '0%', opacity: 1, top: 0 },
    animate: { y: '0%', opacity: 1, top: 0 },
    duration: 0.5,
  };
  const pageSet = [
    {
      num: 0,
      id: 'm0',
      title: '가족정보',
      level: 1,
      active: true,
      subActive: false,
      checked: false,
      child: [],
      icon: 'ri-parent-line',
      status: 'complete',
      statusLabel: '검토완료',
      desc: '홍길동 외 4명 등록',
      subMenus: [],
      content: <MainA num={0} />,
      prop: {
        ...defProps,
        initial: { ...defProps.initial, y: -100 },
        animate: { ...defProps.animate, y: -0, opacity: 1 },
      },
      prevButton: false,
      nextButton: true,
    },
    {
      num: 1,
      id: 'm1',
      title: '연간소득 정보',
      active: false,
      subActive: false,
      checked: false,
      child: [],
      icon: 'ri-wallet-3-line',
      status: 'in_progress',
      statusLabel: '검토 중',
      desc: '총소득 455,000,000만원',
      subMenus: [],
      content: <MainB num={1} />,
      prop: {
        ...defProps,
        initial: { ...defProps.initial, y: -0 },
        animate: { ...defProps.animate, y: -0 },
      },
      prevButton: true,
      nextButton: true,
    },
    {
      num: 2,
      id: 'm2',
      title: '연말정산 입력',
      active: false,
      subActive: false,
      checked: false,
      child: [
        {
          id: '1',
          title: 'Data',
          level: 2,
          url: '/',
        },
      ],
      icon: 'ri-file-edit-line',
      status: 'wait',
      statusLabel: '미진행',
      subMenus: [
        {
          id: 301,
          title: '국민연금/건강보험료 상세',
          icon: 'ri-file-text-line',
          status: 'wait',
          statusLabel: '미진행',
          modalKey: 'insurance_health_pension',
        },
        {
          id: 302,
          title: '보험료 상세',
          icon: 'ri-wallet-2-line',
          status: 'wait',
          statusLabel: '미진행',
          modalKey: 'insurance',
        },
        {
          id: 303,
          title: '의료비 상세',
          icon: 'ri-hospital-line',
          status: 'wait',
          statusLabel: '미진행',
          modalKey: 'medical',
        },
        {
          id: 304,
          title: '교육비 상세',
          icon: 'ri-school-line',
          status: 'wait',
          statusLabel: '미진행',
          modalKey: 'education',
        },
        {
          id: 305,
          title: '기부금 상세',
          icon: 'ri-service-line',
          status: 'wait',
          statusLabel: '미진행',
          modalKey: 'donation',
        },
        {
          id: 306,
          title: '주택자금 상세',
          icon: 'ri-home-2-line',
          status: 'wait',
          statusLabel: '미진행',
          modalKey: 'housing',
        },
        {
          id: 307,
          title: '연금저축등 상세',
          icon: 'ri-funds-box-line',
          status: 'wait',
          statusLabel: '미진행',
          modalKey: 'pension_savings',
        },
        {
          id: 308,
          title: '기타입력 상세',
          icon: 'ri-file-text-line',
          status: 'wait',
          statusLabel: '미진행',
          modalKey: 'others',
        },
        {
          id: 309,
          title: '신용카드 외 상세',
          icon: 'ri-info-card-line',
          status: 'wait',
          statusLabel: '미진행',
          modalKey: 'credit_card',
        },
      ],
      content: <MainC num={2} />,
      prop: {
        ...defProps,
        initial: { ...defProps.initial, y: -300 },
        animate: { ...defProps.animate, y: -300 },
      },
      prevButton: true,
      nextButton: true,
    },
    {
      num: 3,
      id: 'm3',
      title: '제출서류',
      active: false,
      subActive: false,
      checked: false,
      child: [],
      icon: 'ri-folder-open-line',
      status: 'wait',
      statusLabel: '미진행',
      subMenus: [],
      content: <MainD num={3} />,
      prop: {
        ...defProps,
        initial: { ...defProps.initial, y: -0 },
        animate: { ...defProps.animate, y: -0 },
      },
      prevButton: true,
      nextButton: true,
    },
    {
      num: 4,
      id: 'm4',
      title: '연말정산 결과',
      active: false,
      subActive: false,
      checked: false,
      child: [],
      icon: 'ri-article-line',
      status: 'wait',
      statusLabel: '미진행',
      subMenus: [],
      content: <MainE num={4} />,
      prop: {
        ...defProps,
        initial: { ...defProps.initial, y: -500 },
        animate: { ...defProps.animate, y: -500 },
      },
      prevButton: true,
      nextButton: false,
    },
  ];

  return pageSet;
};
